module.exports = __webpack_public_path__ + "img/bebidasImage.c862d2d3.svg";